/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["pages{display:block}pages .mat-column-body{margin-right:25px;overflow:hidden}"];
export { styles as styles };
